/* tslint:disable */
/* eslint-disable */
/**
 * Procon BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyDeviceCountInfoDto
 */
export interface DailyDeviceCountInfoDto {
    /**
     * 
     * @type {number}
     * @memberof DailyDeviceCountInfoDto
     */
    current?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyDeviceCountInfoDto
     */
    remaining?: number;
}

/**
 * Check if a given object implements the DailyDeviceCountInfoDto interface.
 */
export function instanceOfDailyDeviceCountInfoDto(value: object): value is DailyDeviceCountInfoDto {
    return true;
}

export function DailyDeviceCountInfoDtoFromJSON(json: any): DailyDeviceCountInfoDto {
    return DailyDeviceCountInfoDtoFromJSONTyped(json, false);
}

export function DailyDeviceCountInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyDeviceCountInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'] == null ? undefined : json['current'],
        'remaining': json['remaining'] == null ? undefined : json['remaining'],
    };
}

export function DailyDeviceCountInfoDtoToJSON(json: any): DailyDeviceCountInfoDto {
    return DailyDeviceCountInfoDtoToJSONTyped(json, false);
}

export function DailyDeviceCountInfoDtoToJSONTyped(value?: DailyDeviceCountInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': value['current'],
        'remaining': value['remaining'],
    };
}

